import { NgModule } from '@angular/core';
import { BrowserModule, DOCUMENT } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';

import { TabsModule } from 'ngx-bootstrap/tabs';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { AccordionModule } from 'ngx-bootstrap/accordion';

import { SharedComponentModule } from '../shared/shared.module';

import {GetAccountByUsernameService} from '../service/get-account-by-username.service';
import {GetLeagueByAbbrService} from '../service/get-league-by-abbr.service';
import {GetSeasonsForLeagueService} from '../service/get-seasons-for-league.service';
import {GetGameSummariesForSeasonService} from '../service/get-game-summaries-for-season.service';
import {GetTeamSummariesForSeasonService} from '../service/get-team-summaries-for-season.service';

@NgModule({
  declarations: [
  ],
  imports: [
    BrowserModule,
    HttpModule,
    FormsModule,
    ReactiveFormsModule,
    TabsModule.forRoot(),
    ButtonsModule.forRoot(),
    BsDropdownModule.forRoot(),
    AccordionModule.forRoot(),
    SharedComponentModule
  ],
  providers: [
    GetAccountByUsernameService,
    GetLeagueByAbbrService,
    GetSeasonsForLeagueService,
    GetGameSummariesForSeasonService,
    GetTeamSummariesForSeasonService
  ],
  exports: [
  ]
})
export class SharedScoreboardComponentModule { }
